import {Injectable} from '@angular/core';
import {OidcSecurityService, UserDataResult} from 'angular-auth-oidc-client';
import {Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  userData: UserDataResult;
  userData$: Observable<UserDataResult>;
  isAuthenticated: boolean;

  constructor(private oidc: OidcSecurityService) {
    this.userData$ = this.oidc.userData$;
    this.oidc.checkAuth().subscribe(({isAuthenticated, userData, accessToken}) => {
      this.isAuthenticated = isAuthenticated;
      if (userData != null && userData.userData != null) {
        this.userData = userData;
      }
    });
  }

  public getUserData() {
    return this.userData;
  }

  public getUserDataObservable() {
    return this.userData$;
  }

  getUserMail$(): Observable<string> {
    return this.userData$.pipe(
      map(data => data?.userData?.email),
      filter(email => !!email)
    );
  }

  getUserId$(): Observable<string> {
    return this.userData$.pipe(
      map(data => data?.userData?.sub),
      filter(id => !!id)
    );
  }

}
